import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=5c297ea3&scoped=true&"
import script from "./DeliveryForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c297ea3",
  null
  
)

export default component.exports